<ion-item color="medium" mode="ios" (click)="select()" [ngStyle]="{'margin-bottom': (appKey !== 'clinic-portal') ? '24px' : '10px'}">
    <ion-label color="primary placeholder" *ngIf="!provinceCode">{{placeholder}}</ion-label>
    <ion-label color="primary" *ngIf="provinceCode">{{provinceCode | province:countryCode:locale}}</ion-label>
</ion-item>
